import styled from 'styled-components'

export const CounterTitle = styled.div`
  font-size: 20px;
  color: ${(props) => props.theme.colors.text};
  opacity: 0.9;
  line-height: 1.2em;
  font-weight: 500;
  margin-bottom: 6px;
`
export const CounterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 331px;
  border: 2px solid transparent;
  margin: 0 0 12px;
  &.isFocusedLeaf {
    border-color: ${(props) => props.theme.colors.countdown.focusedElem.border};
  }
`

export const CounterElem = styled.div`
  flex: 0 0 78px;
  border-radius: 8px;
  text-align: center;
  overflow: hidden;
  background: ${(props) => props.theme.colors.countdown.background};
`
export const TimeElem = styled.div`
  font-size: 32px;
  color: ${(props) => props.theme.colors.countdown.title};
  line-height: 64px;
  font-weight: 500;
  display: block;
  height: 64px;
`

export const TextElem = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.countdown.text};
  line-height: 30px;
  font-weight: 500;
  display: block;
  height: 30px;
  background: ${(props) => props.theme.colors.countdown.textBackground};
  text-transform: uppercase;
  letter-spacing: -1px;
  opacity: 0.9;
`
export const VideoCountdownWrapper = styled.div<{
  $hidden?: boolean
}>`
  display: flex;
  justify-content: center;
  font-size: 80px;
  color: ${(props) => props.theme.colors.accent};
  line-height: 120px;
  font-weight: 700;
  opacity: ${({ $hidden }) => ($hidden ? '0' : '1')};
  ${CounterElem} {
    flex: 0 0 130px;
    background: none;
  }
`
export const Divider = styled.div`
  display: flex;
  line-height: 100px;
`
